import lightGallery from "lightgallery"
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'

jQuery('.component-youtube-chapters .text a[data-step]').click(function (e) {
  e.preventDefault();
  var step = jQuery(this).data('step');
  var src = jQuery('.component-youtube-chapters .embed-responsive-item').data('src');
  jQuery('.component-youtube-chapters .embed-responsive-item').attr('src', src + '?start=' + step + '&autoplay=1&mute=1');
});

var galleries = document.querySelectorAll('.component-youtube-chapters .images');
galleries.forEach(function (gallery) {
  lightGallery(gallery, {
    selector: 'a',
    licenseKey: '8C1D605B-6C6F4022-9AE1B332-5383DA54'
  });
})
